var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoInvoices(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 180,
    height: 180,
    viewBox: "0 0 180 180",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.63556 93.9536C6.63556 158.127 76.1059 198.236 131.682 166.149C157.475 151.258 173.364 123.737 173.364 93.9536C173.364 29.7796 103.894 -10.3291 48.3178 21.7578C22.5248 36.6494 6.63556 64.1703 6.63556 93.9536Z",
    fill: "#F7EDF3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M47.973 154.32C42.9687 152.861 36.4754 149.729 36.4754 144.805C36.4754 139.362 45.4197 130.996 51.0436 130.996H129.95C135.045 130.996 142.933 139.004 142.933 143.839C142.933 148.155 137.513 150.835 133.117 152.298L93.7748 165.411C91.4155 166.197 88.8723 166.246 86.4847 165.548L47.973 154.32Z",
    fill: "#852E62",
    fillOpacity: 0.2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M90 158.528L45.9999 145.695V96.1945L90 109.028V158.528Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M90 158.528L45.9999 145.695V96.1945L90 109.028V158.528Z",
    stroke: "#852E62",
    strokeWidth: 1.69894,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M79.0001 120.028L35 107.194L45.9999 96.1945L90 109.028L79.0001 120.028Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M90 109.028L45.9999 96.1945L90 83.3612L134 94.3611L90 109.028Z",
    fill: "#EB9DCB",
    stroke: "#852E62",
    strokeWidth: 1.69894,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M90 109.028L45.9999 96.1945L90 83.3612V109.028Z",
    fill: "#EB9DCB",
    stroke: "#852E62",
    strokeWidth: 1.69894,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M145 85.1946L101 74.1945L90 83.3612L134 94.3612L145 85.1946Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M35 85.1946L45.9999 96.1945L90 83.3613L77.1666 74.1945L35 85.1946Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M134 143.861L90 158.528V109.028L134 94.3611L134 143.861Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M134 143.861L90 158.528V109.028L134 94.3611L134 143.861Z",
    stroke: "#852E62",
    strokeWidth: 1.69894,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M90 109.028L102.833 116.361L145 101.694L134 94.3611L90 109.028Z",
    fill: "white",
    stroke: "#852E62",
    strokeWidth: 1.69894,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M35 85.1946L45.9999 96.1945L90 83.3613L77.1666 74.1945L35 85.1946Z",
    stroke: "#852E62",
    strokeWidth: 1.69894,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M79.0001 120.028L35 107.194L45.9999 96.1945L90 109.028L79.0001 120.028Z",
    stroke: "#852E62",
    strokeWidth: 1.69894,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M145 85.1946L101 74.1945L90 83.3612L134 94.3612L145 85.1946Z",
    stroke: "#852E62",
    strokeWidth: 1.69894,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M89.9936 52.6758C88.2409 52.6732 86.8209 51.2525 86.8192 49.4998V45.9798C86.8209 44.2274 88.2412 42.8071 89.9936 42.8054C94.339 42.8051 97.0549 38.101 94.882 34.3379C92.7092 30.5749 87.2774 30.5751 85.1049 34.3383C84.6095 35.1964 84.3488 36.1698 84.3488 37.1606C84.3488 39.6042 81.7034 41.1315 79.5872 39.9097C78.605 39.3426 78 38.2947 78 37.1606C77.9967 27.9229 87.9947 22.1459 95.9963 26.7619C103.998 31.3779 104.002 42.9249 96.0036 47.5465C95.1136 48.0609 94.1611 48.4587 93.1696 48.7302V49.5078C93.1625 51.2576 91.7434 52.6732 89.9936 52.6758Z",
    fill: "white",
    stroke: "#852E62",
    strokeWidth: 1.31932,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M85.936 60.2598C85.936 63.3834 89.3173 65.3355 92.0224 63.7738C93.2779 63.049 94.0512 61.7095 94.0512 60.2598C94.0512 57.1362 90.6698 55.1841 87.9648 56.7458C86.7094 57.4706 85.936 58.8101 85.936 60.2598Z",
    fill: "white",
    stroke: "#852E62",
    strokeWidth: 1.31932,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoInvoices);
export default __webpack_public_path__ + "static/media/no_invoices.cb039b0a3d9075358592ba4c0fc6a93b.svg";
export { ForwardRef as ReactComponent };